import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Clear all service workers and caches to prevent stale builds
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister());
  });
  caches.keys().then(names => {
    names.forEach(n => caches.delete(n));
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out and remove startup loader
const loader = document.getElementById('startup-loader');
if (loader) {
  loader.style.opacity = '0';
  setTimeout(() => loader.remove(), 600);
}
